import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { HubActionTypes, HubActions } from "../../../actionTypes/master/hubActionTypes";
import {
  createHubApi,
  editHubDataByIdApi,
  getHubDataByIdApi,
  getHubListApi,
} from "../../requests/master/hubRequests";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import { setHubDataById, setHubList, setHubListPageCount } from "../../../actions/master/hubActions";


function* createHubHandler(action: HubActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createHubApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getHubListHandler(action: HubActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getHubListApi, action.payload);

    if (data.status) {
      yield put(setHubList(data?.data?.rows));
      yield put(setHubListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getHubDataByIdHandler(action: HubActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getHubDataByIdApi, action.payload);
    if (data.status) {
      yield put(setHubDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editHubDataByIdHandler(action: HubActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editHubDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      // yield put(getHubList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

// hub sagas
export default function* hubSaga() {
  yield takeLatest(HubActions.CREATE_HUB, createHubHandler);
  yield takeLatest(HubActions.GET_HUB_LIST, getHubListHandler);
  yield takeLatest(HubActions.GET_HUB_DATA_BY_ID, getHubDataByIdHandler);
  yield takeLatest(HubActions.EDIT_HUB_DATA_BY_ID, editHubDataByIdHandler);
}
